import React from 'react'
import { useEffect, useState } from 'react';
import './header.css'
import headerImg1 from '../../Assets/headerImg1.jpeg';
import headerImg2 from '../../Assets/headerImg2.jpeg';
import headerImg3 from '../../Assets/headerImg3.jpeg';
const Header = () => {

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [headerImg1, headerImg2, headerImg3];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);



  const scrollToService = () => {
    // Scroll to the car section when the "Cars" link is clicked
    const carSection = document.getElementById('ourService');
    carSection.scrollIntoView({ behavior: 'smooth' });

    // if (click) {
    //   carSection.style.opacity = "1";
    // }
  };

    
  return (
    <>
    {/* Header Section Of the Website */}
    <div className='header'>
         <img className='headerImg' src={images[currentImageIndex]} alt='' />
        <div className="headerText" data-aos="fade-right">
            <h1>Vishal Auto Glass</h1>
            <div className='textPara'>
              <p>Welcome to Vishal Auto Glass! We are your go-to source for quality auto glass repairs, as well as replacement services for cars, trucks, 
                 and also trains,
                 Our goal is to provide you with exceptional service at competitive pricing. 
                 Let us help you get back on the road safely and quickly.</p>
              <button className='button btn btn-warning data-aos="fade-left"' onClick={scrollToService}> See Our Services</button>
            </div>
        </div>
    </div>
    </>

  )
}

export default Header
